import { cn } from '@nesso/ui/lib/utils';
import { Alert, AlertAction, AlertDescription, AlertTitle } from '@nesso/ui/primitives/alert';
import { Button } from '@nesso/ui/primitives/button';

import { formatRelativeDays } from '@/shared/lib/time-utils';

type PaymentFailedAlertProps = {
    onAction: () => void;
    retentionEndsAt?: string | null;
    // 'container' switches on the alert's own width; 'viewport' on the `sm` breakpoint.
    responsive?: 'container' | 'viewport';
};

const INLINE_ACTION = {
    container:
        '@min-[480px]:col-start-3 @min-[480px]:row-start-1 @min-[480px]:row-span-2 @min-[480px]:mt-0 @min-[480px]:ml-2 @min-[480px]:self-center @min-[480px]:justify-self-auto',
    viewport:
        'sm:col-start-3 sm:row-start-1 sm:row-span-2 sm:mt-0 sm:ml-2 sm:self-center sm:justify-self-auto',
} as const;
const BUTTON_SIZE = {
    container: '@min-[480px]:h-6 @min-[480px]:px-3',
    viewport: 'sm:h-6 sm:px-3',
} as const;

export function PaymentFailedAlert({
    onAction,
    retentionEndsAt,
    responsive = 'container',
}: PaymentFailedAlertProps) {
    const description = `Update your card to keep using Nesso. Your account will be deleted${
        retentionEndsAt ? ` ${formatRelativeDays(retentionEndsAt)}` : ''
    } without an updated payment method.`;

    return (
        <Alert variant="destructive" className="grid-cols-[0_minmax(0,1fr)_auto] gap-x-0 mb-0">
            <AlertTitle className="text-sm">Payment failed — don&apos;t lose access</AlertTitle>
            <AlertDescription className="text-sm">{description}</AlertDescription>
            <AlertAction className={INLINE_ACTION[responsive]}>
                <Button
                    className={cn('text-foreground h-9 px-4 text-sm', BUTTON_SIZE[responsive])}
                    variant="outline"
                    size="sm"
                    onClick={onAction}
                >
                    Update Card
                </Button>
            </AlertAction>
        </Alert>
    );
}
